import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosClient from "src/utils/axiosConfig";

export const getCounsellorLogListAsync = createAsyncThunk(
  "getCounsellorLogListAsync",
  async (query, data, toolkit) =>
    AxiosClient({
      toolkit,
      url: `student-personal-counsellor-log/web?page=${query.page}&limit=${query.limit}`,
      method: "get",
      data,
    }),
);

export const CreateTableAsync = createAsyncThunk(
  "CreateTableAsync",
  async (data, toolkit) =>
    AxiosClient({
      toolkit,
      url: "student-personal-counsellor-log/create",
      method: "post",
      data,
    }),
);

export const DeleteTableAsync = createAsyncThunk(
  "DeleteTableAsync",
  async (data, toolkit) =>
    AxiosClient({
      toolkit,
      url: "university-sort-listing/remove-student-university",
      method: "post",
      data,
    }),
);
